import React from "react";
import "./Device.css";
import {renderActions} from "../../../../BondTree/Devices/Device";
import Row from "react-bootstrap/Row";
import Card from 'react-bootstrap/Card';
import iconMS from "components/CustomApplications/TestApp/assets/img/devices/MS.png";
import iconCF from "components/CustomApplications/TestApp/assets/img/devices/CF.png";
import iconLT from "components/CustomApplications/TestApp/assets/img/devices/LT.png";
import iconFP from "components/CustomApplications/TestApp/assets/img/devices/FP.png";

const deviceTypeIcon = {
    "MS": iconMS, "CF": iconCF, "LT": iconLT, "FP": iconFP
}

function Device({device}) {
    return (<Row className="deviceRow">
        <Card className={"deviceCard"}>
            <Card.Body>
                <Card.Title>
                    <img className={'deviceTypeIcon'} src={deviceTypeIcon[device.data.type]}
                         alt={device.data.name}/>
                    {device.data.name}
                </Card.Title>
                <Card.Body className={'testAppDevice'}>
                    {renderActions(device.data.actions, device._bondApi, `/devices/${device.deviceId}/`, "testAppDeviceActions")}
                </Card.Body>
            </Card.Body>
        </Card>
    </Row>);
}

export default Device;
